import {
  TaxPaymentActionTypes,
  TaxPaymentStateTypes,
} from "./TaxPayment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: TaxPaymentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const TaxPaymentReducer = (
  state: TaxPaymentStateTypes = INITIAL_STATE,
  action: any
): TaxPaymentStateTypes => {
  switch (action.type) {
    case TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT:
      return {
        ...state,
        fetchAll: {
          isPending: true,
          isSuccessful: false,
          payload: [],
          error: null,
        },
      };
    case TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          isPending: false,
          isSuccessful: false,
          payload: [],
          error: action.payload,
        },
      };
    case TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
          error: null,
        },
      };
    case TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT:
      return {
        ...state,
        fetchOne: {
          isPending: true,
          isSuccessful: false,
          payload: {},
          error: null,
        },
      };
    case TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState({}),
      };
    case TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          isPending: false,
          isSuccessful: false,
          payload: {},
          error: action.payload,
        },
      };
    case TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
          error: null,
        },
      };
    default:
      return state;
  }
};

export default TaxPaymentReducer;
